import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    path,
    mergeDeepLeft,
    clone,
} from 'ramda';
import Breadcrumbs from '../../common/Breadcrumbs';
import Input from '../../common/Input';
import TableAjax from '../../сomponents/TableAjax';
import ConfirmAction from '../../common/ConfirmAction';
import UpdateActivityPopup from "./updateActivityPopup";
import {fetchActivities, downloadReportExcel} from '../../api/reports';
import {createActivity, deleteActivity, updateActivityDuration} from '../../api/checkIn';
import DatePicker from '../../common/DatePicker';
import fields from './field';
import moment from '../../config/custom-moment';
import Preloader from '../../common/Preloader';
import './style.css';
import CheckBox from "../../common/CheckBox";
import {deleteAllReports, finishedAllActivitiesOnWorkTimePage} from '../../actions/reports';


import { fetchDetailsWithoutProperty } from '../../api/dashboard';
import fieldsDashboard from '../Dashboard/fields';
import ReactSelectWrapper from '../../common/ReactSelectWrapper';
import {durationToString, makeTimestampForLocationTimeZone} from '../../utils/date';
import { fetchWorkers } from '../../api/employees';
import {deleteObject} from "../../actions/objectToDelete";
import {changeModalState} from "../../actions/modal";
import {getList} from "../../api/projects";
import {fetchAllData as getBoardStages} from "../../api/boardSettings";
import CreateActivityPopup from "./createActivityPopup";
import CustomTinyBarChart from "../../common/CustomTinyBarChart";
import PieChartWithCustomizedLabel from "../../common/PieChartWithCustomizedLabel";

const TIME_RANGE_DATE_FORMAT = 'MM/DD/YYYY';
const DEFAULT_SORT = 'started_at|desc';

const DEFAULT_STATE = {
  itemsList: [],
  container: false,
  search: '',
  fields: clone(fields),
  loading: false,
  itemsCount: 0,
  itemsPerPage: 10,
  currentPage: 0,
  projectsFields: [],
  workerOptions: [],
  customerOptions: [],
  activityOptions: [],
  selectedFields: [],
  totalSpent: 0,
  showDiagram: false,
  sort: DEFAULT_SORT,
};

export class Timesheet extends Component {

    constructor(props) {
        super(props);
        this.reloadData = this.reloadData.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.changeFormValue = this.changeFormValue.bind(this);
        this.handleFormValueChange = this.handleFormValueChange.bind(this);
        this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.getFilters = this.getFilters.bind(this);
        this.getPaginationParams = this.getPaginationParams.bind(this);
        this.getAllParams = this.getAllParams.bind(this);
        this.getReportItems = this.getReportItems.bind(this);
        this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
        this.onSetField = this.onSetField.bind(this);
        this.setProjectFields = this.setProjectFields.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlerDelete = this.handlerDelete.bind(this);
        this.handlerEdit = this.handlerEdit.bind(this);
        this.addActivity = this.addActivity.bind(this);
        this.handlerWo = this.handlerWo.bind(this);
        this.showDiagram = this.showDiagram.bind(this);

        this.state = DEFAULT_STATE;

        this.columns = [
            'firstname',
            'activity_name',
            'wo_number',
            'customer_name',
            'task_description',
            'started_at',
            'stopped_at',
            'duration'
        ];

        this.sortableColumns = [
            'firstname',
            'started_at',
            'stopped_at'
        ];

        this.columnNames = [
            'Worker',
            'Activity',
            'Work Order',
            'Customer',
            'Description',
            'Started',
            'Finished',
            'Time Spent',
        ];
    }

    reloadData() {
      this.props.list(this.getAllParams());
    }

    componentDidMount() {
      const { getStages, getWorkers, deleteAllReports, list, getCustomerList, stageList } = this.props;

      getStages();
      getWorkers();
      deleteAllReports();
      getCustomerList();
      stageList();

      const woNumber = path(['match', 'params', 'wo'], this.props);
      if (woNumber) {
        this.setState({ ...{loading: true},
          ... this.changeFormValue("work_order_filter", {value: woNumber})}, () => {
          list(this.getAllParams());
        });
      } else {
        this.setState({loading: true}, () => {
          list(this.getAllParams());
        });
      }
    }

    onSearch(text) {
        this.setState({
            search: text,
        }, this.reloadData);
    }

    onSetField(i, id, val) {
        const { projectsFields } = this.state;
        const newField = [...projectsFields];
        newField[i] = val;
        const selectedIds = [];
        for (let i = 0; i < newField.length; i++) {
            if (newField[i].value) {
                selectedIds.push(newField[i].id)
            }
        }
        this.setState({ selectedFields: selectedIds, projectsFields: [...newField] }, () => {
            // this.reloadArchive(true);
        })
    }

    onChangeCurrentPage(currentPage) {
      this.setState({ ...{currentPage}, ...{loading: true} }, () => {this.reloadData()});
    }

    onChangeItemsPerPage(e) {
        e.preventDefault();
        this.setState({
            itemsPerPage: e.target.value,
            loading: true,
          }, () => {this.reloadData()}
        );
    }

    getFilters() {
        const filters = {};

        const dateFrom = this.state.fields['filter_date_from'].value;
        const dateTo = this.state.fields['filter_date_to'].value;
        const workerId = this.state.fields['worker_filter'].value;
        const workOrderId = this.state.fields['work_order_filter'].value;

        if (!!this.state.search) {
            filters['search'] = this.state.search;
        }

        if (dateTo) {
            filters['date_end'] = moment(dateTo).format('YYYY-MM-DD');
        }

        if (dateFrom) {
            filters['date_start'] = moment(dateFrom).format('YYYY-MM-DD');
        }

        if (workerId) {
            filters['user_id'] = workerId;
        }

        if (workOrderId) {
            filters['task_name'] = workOrderId;
        }

        filters['sort'] = this.state.sort;

        const { projectsFields } = this.state;
        const projectFilterFields = projectsFields.filter(field => field.type === 'lanes').map(field => field.id);

        if (projectFilterFields && projectFilterFields.length) {
            filters['project-id'] = projectFilterFields;
        }
        return filters;
    }

    componentWillReceiveProps(newProps) {
        const lanes = path(['dashboard', 'lanes'], newProps);
        const workers = path(['employees', 'workers'], newProps);
        const customers = path(['projects', 'list'], newProps);

        if (workers && workers.length) {
            this.setState({
                workerOptions: workers.map(worker => ({
                    label: `${worker.firstname} ${worker.lastname}`,
                    value: worker.id
                }))
            });
        }

        if (customers && customers.length) {
            this.setState({
                customerOptions: customers.map(customer => ({
                  label: customer.name,
                  value: customer.id,
                }))
            });
        }

        if (this.state.projectsFields.length === 0 && lanes) {
            this.setProjectFields(lanes);
        }

      const loadedNewData = path(['reports', 'loadedNewData'], newProps);

      const { loading } = this.state;

      if (loadedNewData === true && loading === true) {
        this.setState({loading: false});
        this.props.finishLoading(false);
      }
    }

  setProjectFields(lanes) {
        let selectedIds = [];
        const projectFields = [fieldsDashboard.search, {
            label: 'Unassigned',
            placeholder: '',
            system: {
                name: '',
            },
            value: true,
            errors: [],
            type: 'lanes',
            id: 0,
            name: 'project_' + 0,
            rules: {
                title: '',
                required: false,
            }
        }];
        for (let i = 0; i < lanes.length; i++) {
            let currentField = {
                label: lanes[i].label,
                placeholder: '',
                system: {
                    name: '',
                },
                value: true,
                errors: [],
                id: lanes[i].id,
                type: 'lanes',
                name: 'project_' + lanes[i].id,
                rules: {
                    title: '',
                    required: false,
                }
            };

            selectedIds.push(lanes[i].id);

            projectFields.push(currentField);
        }
        this.setState({
            selectedFields: selectedIds,
            projectsFields: projectFields,
        });
    }

    handleSort(sortBy, sortDirection) {
      this.setState({ sort: `${sortBy}|${sortDirection}`, loading: true }, () => {this.reloadData()});
    }

    handleFormValueChange(field, newObject) {
      this.setState(this.changeFormValue(field, newObject));
    }

    changeFormValue(field, newObject) {
        let stateClone = clone(this.state);
        stateClone.fields[field] = newObject;

        if (field === 'time_range') {
            let dateStart = '';
            let dateEnd = '';

            switch (newObject.value) {
                case 'Today':
                    dateStart = moment().format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'Yesterday':
                    dateStart = moment().subtract(1, 'day').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().subtract(1, 'day').format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'This Week':
                    dateStart = moment().startOf('week').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                case 'This Month':
                    dateStart = moment().startOf('month').format(TIME_RANGE_DATE_FORMAT);
                    dateEnd = moment().format(TIME_RANGE_DATE_FORMAT);
                    break;
                default:
                    break;
            }

            stateClone.fields['filter_date_to'].value = dateEnd;
            stateClone.fields['filter_date_from'].value = dateStart;
        }

        return mergeDeepLeft(stateClone, this.state);
    }

    fixDataForTable(data) {
        return data.map(dataPoint => ({
            id: dataPoint.id,
            firstname: `${dataPoint.firstname}  ${dataPoint.lastname}`,
            activity_name: dataPoint.activity_name,
            wo_number: dataPoint.wo_number,
            customer_name: dataPoint.customer_name,
            task_description: dataPoint.task_description,
            started_at: dataPoint.started_at ? moment.unix(dataPoint.started_at).format('MM/DD/YYYY h:mma') : '',
            stopped_at: dataPoint.stopped_at ? moment.unix(dataPoint.stopped_at).format('MM/DD/YYYY h:mma') : '',
            duration: durationToString(dataPoint.duration)
        }));
    }

    getPaginationParams() {
      return { per_page: this.state.itemsPerPage, page: this.state.currentPage + 1, length: -1 };
    }

    getAllParams() {
      return {
        ...this.getPaginationParams(),
        ...this.getFilters(),
      };
    }

    applyFilter() {
        this.props.deleteAllReports();
        this.setState({ loading: true, currentPage: 0}, () => {
          this.props.list(this.getAllParams());
        });
    }

    handlerDelete(id) {
      this.props.handleObjectToDelete({
        id: parseInt(id),
        handler: ((data) => {
          return (dispatch) => {
            return deleteActivity(data, () => {
              this.setState({ loading: true }, () => {
                this.props.list(this.getAllParams());
              });
            })(dispatch);
          }
        }),
      });

      this.props.handleModalState({
        isOpen: !this.props.modal.isOpen,
        modalId: 'deleteActivityById',
      });
    }

    handlerWo(id) {
      const itemsList = path(['reports', 'activities', 'data'], this.props);
      for (let i = itemsList.length; i--;) {
        if (itemsList[i].id === id) {
          window.open('/pages/task/' + itemsList[i].task_id);
        }
      }
    }

    addActivity() {
      const now = new Date();
      const currentDate = Math.floor(now.getTime() / 1000);
      this.props.handleModalState({
        wo_number: null,
        started_at: currentDate,
        stopped_at: currentDate,
        activity: null,
        worker: null,
        customer: null,
        handler: ((data) => {
          return (dispatch) => {
            return createActivity(data, () => {
              this.setState({ loading: true }, () => {
                this.props.list(this.getAllParams());
              });
            })(dispatch);
          }
        }),
        isOpen: !this.props.modal.isOpen,
        modalId: 'createActivityPopup',
      });
    }

    handlerEdit(id) {
      const itemsList = path(['reports', 'activities', 'data'], this.props);
      const item = itemsList.find(item => item.id === id);
      const started_at = makeTimestampForLocationTimeZone(item.started_at);
      const stopped_at = makeTimestampForLocationTimeZone(item.stopped_at);

      this.props.handleModalState({
        id: id,
        wo_number: item.wo_number,
        started_at: started_at,
        stopped_at: stopped_at,
        activity: item.type_id,
        worker: item.user_id,
        customer: item.customer_id,
        handler: ((data) => {
          return (dispatch) => {
            return updateActivityDuration(data, () => {
              this.setState({ loading: true }, () => {
                this.props.list(this.getAllParams());
              });
            })(dispatch);
          }
        }),
        isOpen: !this.props.modal.isOpen,
        modalId: 'updateActivityPopup',
      });
    }

    getReportItems() {
        const itemsList = path(['reports', 'activities', 'data'], this.props);

        const itemsCount = path(['reports', 'activities', 'total'], this.props);

        if (!itemsList) {
            return null;
        }

      const itemActions = {
        login: {
          handler: this.handlerWo,
          icon: ['fa fa-circle-thin icon-stack-3x', 'material-icons md-style'],
          iconClass: '',
          permission: { 'permAreaKey': 'time_tracking', 'permTypeKey': 'view' },
          context: this,
          hasWrapper: true,
          title: 'Open WO',
        },
        edit: {
          handler: this.handlerEdit,
          permission: { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' },
          condition: true,
          icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
          iconClass: '',
          context: this,
          hasWrapper: true,
          title: 'Edit',
        },
        delete: {
          authorColumnName: 'user_id',
          permission: { 'permAreaKey': 'time_tracking', 'permTypeKey': 'edit' },
          handler: this.handlerDelete,
          icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
          iconClass: '',
          context: this,
          hasWrapper: true,
          title: 'Delete',
        }
      };
      const sortBy = this.state.sort.split('|');

        return (
          <TableAjax
            items={this.fixDataForTable(itemsList)}
            columns={this.columns}
            columnNames={this.columnNames}
            sortable={this.sortableColumns}
            itemsPerPage={this.state.itemsPerPage}
            itemsPerPageLabel={'Items Per Page'}
            itemsCount={itemsCount}
            hideSearch={true}
            search={this.state.search}
            actions={itemActions}
            currentPage={this.state.currentPage}
            onChangeCurrentPage={this.onChangeCurrentPage}
            onApplySearch={this.onSearch}
            searchPosition='left'
            onChangeItemsPerPage={this.onChangeItemsPerPage}
            onChangeSorting={this.handleSort}
            defaultSort={{
              column: sortBy[0],
              direction: sortBy[1]
            }}
          />
        );
    }

    getPieChartWithCustomizedLabelData() {
      const items = path(['reports', 'activities', 'group_activities'], this.props);
      if (!items) {
        return [];
      }
      return items.map((item) => {
        item.value = parseInt(item.value);
        return item;
      });
    }

    getCustomTinyBarChartData()
    {
      const items = path(['reports', 'activities', 'group_duration'], this.props);
      if (!items) {
        return [];
      }

      return items;
    }

    showDiagram() {
      this.setState({
        showDiagram: !this.state.showDiagram
      });
    }

    getProjects() {
        const projects = [];
        for (let i = 0; i < this.state.projectsFields.length; i++) {

            if (this.state.projectsFields[i].type == 'lanes') {

                projects.push(
                    <div style={{
                        display: 'inline-block',
                        border: '1px solid rgba(0, 0, 0, 0.125)',
                        borderRadius: '4px',
                        padding: '5px',
                        marginRight: '5px',
                        marginBottom: '5px',
                    }}>
                        <CheckBox
                            customize={{
                                margin: '0',
                                paddingTop: '0',
                                paddingBottom: '0',
                            }}
                            key={i}
                            field={this.state.projectsFields[i]}
                            onChange={(e, val) => this.onSetField(i, this.state.projectsFields[i].id, val)}
                        />
                    </div>
                );
            }
        }
        return projects;
    }


    render() {
        const { loading } = this.state;
        const mainPart = loading ? <Preloader show={true} type={'circle'} /> : this.getReportItems();
        let linesPart = this.getProjects();
        const totalSpent = path(['reports', 'activities', 'total_duration'], this.props);

        const downloadExcel = (
            <button
                className="btn btn-rounded btn-icon ui-btn pull-right"
                style={{ borderRadius: '4px' }}
                onClick={() => this.props.downloadReport()}
            >
                <a>
                    <i className="fa fa-download"></i>
                    Report
                </a>
            </button>
        );

        return (
            <div style={{ paddingBottom: '25px' }}>
                <Breadcrumbs list={[
                    { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
                    { icon: 'account_balance_wallet', name: 'Reports' },
                    { icon: 'account_balance_wallet', name: 'Timesheet' },
                ]} />
                <div className="card rounded">
                    <div className="card-header rounded-top">
                        Timesheet
                    </div>
                    <div className="card-block">
                        <div className="clearfix mb-3">
                            {downloadExcel}
                            <button
                                className="btn btn-rounded btn-icon ui-btn pull-right"
                                onClick={this.applyFilter}
                                style={{ marginRight: '10px', borderRadius: '4px', }}
                            >
                                <i className="fa fa-filter"></i>
                                Apply filter
                            </button>
                            <button
                              className="btn btn-rounded btn-icon ui-btn pull-right"
                              onClick={this.addActivity}
                              style={{ marginRight: '10px', borderRadius: '4px', }}
                            >
                              <i className="material-icons">add_circle_outline</i>
                              Add activity
                            </button>
                        </div>
                        <div className="row">
                            <div className="col col-md-12">
                                <b>Projects:</b>
                            </div>
                        </div>

                        <div className="row" style={{ paddingBottom: 10 }}>
                            <div className="col col-md-12">
                                {linesPart}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col col-md-4">
                                <ReactSelectWrapper
                                    options={[
                                        {
                                          'label': '-- All --',
                                          'value': ''
                                        },
                                        {
                                            'label': 'Today',
                                            'value': 'Today'
                                        },
                                        {
                                            'label': 'This Week',
                                            'value': 'This Week'
                                        },
                                        {
                                            'label': 'This Month',
                                            'value': 'This Month'
                                        },
                                        {
                                            'label': 'Yesterday',
                                            'value': 'Yesterday'
                                        }
                                    ]}
                                    field={this.state.fields['time_range']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>
                            <div className="col col-md-4">
                                <DatePicker
                                    field={this.state.fields['filter_date_from']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>
                            <div className="col col-md-4">
                                <DatePicker
                                    field={this.state.fields['filter_date_to']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>
                            <div className="col col-md-4">
                                <ReactSelectWrapper
                                    options={this.state.workerOptions}
                                    field={this.state.fields['worker_filter']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>
                            <div className="col col-md-4">
                                <Input
                                    field={this.state.fields['work_order_filter']}
                                    onChange={this.handleFormValueChange}
                                />
                            </div>

                          <div className="col col-md-4 mt-4">
                            <CheckBox
                              field={this.state.fields['show_diagram']}
                              onChange={this.showDiagram}
                            />
                          </div>
                        </div>

                        <div className="row">
                            <div className="col col-md-12 text-right">
                              Total: {durationToString(totalSpent)}
                            </div>
                        </div>

                        {this.state.showDiagram &&
                          <div className="row">
                            <div className="col col-md-6">
                              <PieChartWithCustomizedLabel
                                data={this.getPieChartWithCustomizedLabelData()}
                              />
                            </div>
                            <div className="col col-md-6">
                              <CustomTinyBarChart
                                data={this.getCustomTinyBarChartData()}
                              />
                            </div>
                          </div>
                        }

                        {mainPart}
                        <ConfirmAction />
                    </div>
                </div>
                <ConfirmAction id={'deleteActivityById'} />
                <UpdateActivityPopup id={'updateActivityPopup'}/>
                <CreateActivityPopup id={'createActivityPopup'}/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state;
};

const mapDispatchToProps = (dispatch) => {
    return {
        getStages: () => {
            fetchDetailsWithoutProperty()(dispatch);
        },
        downloadReport: () => {
            downloadReportExcel('activities', 'Timesheet-Report.csv')(dispatch);
        },
        getWorkers: () => {
            fetchWorkers()(dispatch);
        },
        finishLoading: (data) => {
          dispatch(finishedAllActivitiesOnWorkTimePage(data))
        },
        list: (data) => {
            fetchActivities(data)(dispatch);
        },
        deleteAllReports: () => {
            dispatch(deleteAllReports())
        },
        handleObjectToDelete: (data) => {
          dispatch(deleteObject(data));
        },
        handleModalState: (data) => {
          dispatch(changeModalState(data));
        },
        stageList: () => {
          getBoardStages()(dispatch);
        },
        getCustomerList: () => {
          getList()(dispatch);
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Timesheet);



// WEBPACK FOOTER //
// ./src/containers/Reports/timesheet.js